export default {
  banner: {
    title: "你只需为",
    "title-other": "付费",
    MAU: "活跃用户",
    "section-one": {
      title: "免费计划",
      button: "免费使用",
      descript: "多达 3,000 次免费的 API 调用，体验所有功能。",
    },
    "section-two": {
      title: "复杂的场景？",
      button: "咨询专家",
      descript: "从今天起，贵司的成功就是我们的成功。",
    },
  },
  priceList: {
    "contact-sales": "详情咨询销售",
    alsoInclude: "同时包括：",
    MAU: "活跃用户",
    "month-unit": "月",
    "year-unit": "年",
    unit: "个",
    "contact-us": "联系我们",
    "common-tip": "在一个月内，在单个用户池中进行身份验证的任何用户。",
    payway: {
      month: "按月支付",
      year: "按年支付",
      "comment-one": "订阅 1 年，即免 2 个月费用。不同于其他厂商，Authing 只对",
      "comment-two": "收费。",
    },
    develop: {
      freeText: "所有免费功能",
      title: "开发者版",
      fun: {
        item1: {
          text: "社交账号连接",
          comment:
            "支持主流的社交平台，例如微信、微博和 GitHub，并且可以与 OAuth2 或 OIDC 兼容的任何身份提供商一起使用。",
        },
        item2: {
          text: "长达 3 天的审计日志存储",
          comment:
            "更长的日志数据存储时间，可以满足合规性要求，有助于追溯、取证、分析、诊断和解决身份验证的问题。",
        },
        item3: {
          text: "外部用户管理",
          comment:
            "Authing 提供简单而快速的用户管理界面，帮助管理员管理全部用户的身份，包括用户创建、配置、密码重置、阻止和删除用户。背后是 Authing 全面而强大的 API。",
        },
        item4: {
          text: "角色、权限管理",
          comment: "具有创建分组和权限的能力，提供精细的访问控制。",
        },
        item5: {
          text: "登录框组件、域名和邮件定制",
          comment:
            "Authing 支持使用主流框架的「用户登录框」Web 界面组件。Guard 是一个简单而快速的身份验证窗口组件，美观的样式可以反映出你的品牌格调，并且无需任何代码，就可以支持用户登录的各种高级功能。",
        },
      },
    },
    developPro: {
      freeText: "所有高级版功能",
      title: "高级版",
      fun: {
        item1: {
          text: "2 个企业身份连接",
          comment:
            "Authing 支持以 SAML、钉钉、企业微信等身份提供商对企业的内部人员进行身份验证。",
        },
        item2: {
          text: "长达 10 天的审计日志存储",
          comment:
            "更长的日志数据存储时间，可以满足合规性要求，有助于追溯、取证、分析、诊断和解决身份验证的问题。",
        },
        item3: {
          text: "无限的社交账号连接",
          comment:
            "支持主流的社交平台，例如微信、微博和 GitHub，并且可以与 OAuth2 或 OIDC 兼容的任何身份提供商一起使用。",
        },
        item4: {
          text: "内部人员身份",
          comment: "支持通过企业身份对公司内部的员工进行身份验证和用户同步。",
        },
        item5: {
          text: "协作管理员",
          comment:
            "可为 Authing 控制台添加协作管理员，还可以为不同的管理员配置不同的控制台操作权限，实现基于角色的访问控制。",
        },
        item6: {
          text: "多因素认证基础功能",
          comment:
            "「Authing 小登录」是一个功能强大的多因素认证工具，该工具无需下载，以微信小程序的方式轻松验证用户的身份。打开「Authing 小登录」，就能看到一串一次性密码，让用户登录变得更安全。",
        },
        item7: {
          text: "10 个身份工作流",
          comment:
            "Authing 工作流为一组运行在云端的用户自定义 JavaScript 代码，可以让开发者扩展、自定义 Authing 能力。",
        },
        item8: {
          text: "企业系统集成",
          comment: "Authing 可与你现有的企业应用生态快速集成。",
        },
        item9: {
          text: "99.9% SLA",
          comment: "SLA（服务级别协议）是 Authing 对终端用户的可用性的承诺。",
        },
      },
    },
    enterprise: {
      freeText: "所有企业版功能",
      title: "企业版",
      fun: {
        item1: {
          text: "无限的企业身份连接",
          comment:
            "Authing 支持以 SAML、钉钉、企业微信、AD/LDAP 等身份提供商对企业的内部人员进行身份验证。",
        },
        item2: {
          text: "长达 30 天的审计日志存储",
          comment:
            "更长的日志数据存储时间，可以满足合规性要求，有助于追溯、取证、分析、诊断和解决身份验证的问题。",
        },
        item3: {
          text: "私有云部署（可加购）",
          comment:
            "一种私有化的 Authing 部署模型，比标准的公有云产品更具可用性、安全性和合规性。客户可以选择在自己的基础设施上部署私有版的 Authing。",
        },

        item4: {
          text: "无限的社交账号连接",
          comment:
            "支持主流的社交平台，例如微信、微博和 GitHub，并且可以与 OAuth2 或 OIDC 兼容的任何身份提供商一起使用。",
        },
        item5: {
          text: "企业系统集成",
          comment: "Authing 可与你现有的企业应用生态快速集成。",
        },
        item6: {
          text: "单点登录应用面板",
          comment:
            "Authing 应用面板是所有应用的一站式门户。一旦用户登录，他将看到一个定制化的单点登录面板，其中是 IT 分配给他的所有应用。只需在一个面板上轻点应用，即可轻松登录任何企业软件，自动登录，无需重新输入任何账密。",
        },
        item7: {
          text: "99.99% SLA",
          comment: "SLA（服务级别协议）是 Authing 对终端用户的可用性的承诺。",
        },
        item8: {
          text: "30 分钟内紧急响应",
          comment:
            "由于 Authing 的缺陷导致的紧急事件，优先级将决定响应的时间和性质。",
        },
        item9: {
          text: "定制化、个性化功能",
          comment: "Authing 支持为客户单独定制解决方案，支持产品能力定制。",
        },
        item10: {
          text: "电话/会议客服",
          comment: "5x8 小时即时售后支持：电话/会议、专属服务群支持。",
        },
        item11: {
          text: "应用对接支持、培训",
          comment:
            "包含人工对接支持服务，包含问题排查和必要的远程协助，确保对接使用顺利。",
        },
        item12: {
          text: "专属客户经理",
          comment: "专属客户经理沟通最佳方案，输出最佳实践。",
        },
      },
    },
  },
  guide: {
    title: "构建还是购买：身份管理的评估指南",
    subtitle: "什么是身份管理？应该构建还是购买？下载免费的 Authing 电子书",
    button: "下载电子书",
  },
  compare: {
    title: "功能比较",
    develop: "开发者版",
    "develop-pro": "高级版",
    enterprise: "企业版",
    authentication: {
      title: "认证方式",
      feature1: {
        title: "外部用户身份",
        tip:
          "在某一个月的单个用户池中，任何进行身份验证的任何外部（非员工）用户。",
        "list-one": "多达 50,000 个活跃用户",
        "list-two": "多达 50,000 个活跃用户",
        "list-three": "根据需要",
      },
      feature2: {
        title: "社交账号连接",
        tip:
          "支持主流的社交平台，例如微信、微博和 GitHub，并且可以与 OAuth2 或 OIDC 兼容的任何身份提供商一起使用。",
        "list-one": "无限个",
        "list-two": "无限个",
        "list-three": "无限个",
      },
      feature3: {
        title: "内部人员身份",
        tip:
          "支持通过连接企业身份提供商，例如 SAML、企业微信或 AD/LDAP 对公司内部员工进行身份验证。",
        "list-one": "",
        "list-two": "多达 50,000 名员工",
        "list-three": "根据需要",
      },
      feature4: {
        title: "企业身份连接",
        tip:
          "Authing 支持以 SAML、AD/LDAP 或企业微信等的 企业身份提供商的联合登录对用户进行身份验证。",
        "list-one": "",
        "list-two": "2 个",
        "list-three": "无限",
      },
    },
    userManagement: {
      title: "用户管理",
      feature1: {
        title: "审计日志存储",
        tip:
          "更长的日志数据存储时间，可以满足合规性要求，有助于追溯、取证、分析、诊断和解决身份验证的问题。",
        "list-one": "⻓达 3 天",
        "list-two": "⻓达 10 天",
        "list-three": "⻓达 30 天",
      },
      feature2: {
        title: "用户管理",
        tip:
          "Authing 提供简单而快速的用户管理界面，帮助管理员管理全部用户的身份，包括用户创建、配置、密码重置、阻止和删除用户。背后是 Authing 全面而强大的 API。",
        "list-one": "checked",
        "list-two": "checked",
        "list-three": "checked",
      },
      feature3: {
        title: "⻆色、权限管理",
        tip: "具有创建分组和权限的能力，提供精细的访问控制。",
        "list-one": "checked",
        "list-two": "checked",
        "list-three": "checked",
      },
      feature4: {
        title: "协作管理员",
        tip:
          "可为 Authing 控制台添加协作管理员，还可以为不同的管理员配置不同的控制台操作权限，实现基于⻆色的访问控制。",
        "list-one": "",
        "list-two": "checked",
        "list-three": "checked",
      },
    },
    security: {
      title: "安全",
      feature1: {
        title: "短信验证码",
        tip:
          "这是一种使用用户名/密码对用户进行身份验证的替代方法。Authing 支持通过短信传递的一次性密码。",
        "list-one": "包含 300 条/月，增购 0.079 元/条",
        "list-two": "包含 1,500 条/月，增购 0.079 元/条",
        "list-three": "包含 12,000 条/月，增购 0.079 元/条",
      },
      feature2: {
        title: "多因素认证基础功能",
        tip:
          "「Authing 小登录」是一个功能强大的多因素认证工具，该工具无需下载，以微信小程序的方式轻松验证用户的身份。打开「Authing 小登录」，就能看到一串一次性密码，让用户登录变得更安全。 ",
        "list-one": "",
        "list-two": "checked",
        "list-three": "checked",
      },
    },
    enterprisePersonal: {
      title: "企业个性化",
      feature1: {
        title: "登录框组件、域名和邮件定制",
        tip:
          "Authing 使用主流框架的 Web 和单页应用的「用户登录框」界面组件。 Guard 是一个简单而快速的身份验证窗口组件，美观的样式可以反映出你的品牌格调，并且无需任何代码，就可以支持用户登录的各种高级功能。",
        "list-one": "checked",
        "list-two": "checked",
        "list-three": "checked",
      },
      feature2: {
        title: "可自定义的邮件模版",
        tip:
          "邮件模板和参数配置，使可以自定义 Authing 发送的电子邮件的外观和发件人身份，作为身份验证的工作流的一部分。",
        "list-one": "checked",
        "list-two": "checked",
        "list-three": "checked",
      },
      feature3: {
        // title: "私有云部署服务",
        // tip:
        //   "一种私有化的 Authing 部署模型，比标准的公有云产品更具可用性、安全性和合规性。客户可以选择在自己的基础设施上部署私有版的 Authing。",
        // "list-one": "",
        // // "list-two": "可加购（38,199 人民币/年）",
        // // "list-three": "已包括",
        // "list-two": "",
        // "list-three": "可加购",
        title: "单点登录应用面板",
        tip:
          "Authing 应用面板是所有应用的一站式门户。一旦用户登录，他将看到一个定制化的单点登录面板，其中是 IT 分配给他的所有应用。只需在一个面板上轻点应用，即可轻松登录任何企业软件，自动登录，无需重新输入任何账密。",
        "list-one": "",
        "list-two": "",
        "list-three": "checked",
      },
      feature4: {
        title: "企业系统集成",
        tip: "Authing 可与你现有的企业应用生态快速集成。",
        "list-one": "",
        "list-two": "checked",
        "list-three": "checked",
      },
      feature5: {
        title: "定制开发工程师",
        "list-one": "",
        "list-two": "799 RMB/人时",
        "list-three": "高级版的 8 折",
      },
      feature6: {
        // title: "单点登录应用面板",
        // tip:
        //   "Authing 应用面板是所有应用的一站式门户。一旦用户登录，他将看到一个定制化的单点登录面板，其中是 IT 分配给他的所有应用。只需在一个面板上轻点应用，即可轻松登录任何企业软件，自动登录，无需重新输入任何账密。",
        // "list-one": "",
        // "list-two": "",
        // "list-three": "checked",
        title: "私有云部署服务",
        tip:
          "一种私有化的 Authing 部署模型，比标准的公有云产品更具可用性、安全性和合规性。客户可以选择在自己的基础设施上部署私有版的 Authing。",
        "list-one": "",
        // "list-two": "可加购（38,199 人民币/年）",
        // "list-three": "已包括",
        "list-two": "",
        "list-three": "可加购",
      },
    },
    support: {
      title: "企业支持服务",
      feature1: {
        title: "客服时间",
        "list-one": "工作时间",
        "list-two": "工作时间",
        "list-three": "全年 24 小时",
      },
      feature2: {
        title: "响应时间",
        "list-one": "24 小时内可紧急响应",
        "list-two": "1 小时内可紧急响应",
        "list-three": "30 分钟内可紧急响应",
      },
      feature3: {
        title: "微信客服",
        "list-one": "checked",
        "list-two": "checked",
        "list-three": "checked",
      },
      feature4: {
        title: "服务级别",
        "list-one": "",
        "list-two": "99.9%",
        "list-three": "99.99%",
      },
      feature5: {
        title: "应用对接支持、培训",
        "list-one": "",
        "list-two": "699 RMB/人时",
        "list-three": "高级版的 8 折",
      },
      feature6: {
        title: "电话/会议客服",
        "list-one": "",
        "list-two": "",
        "list-three": "checked",
      },
      feature7: {
        title: "专属客户经理",
        "list-one": "",
        "list-two": "",
        "list-three": "checked",
      },
    },
  },
  question: {
    title: "常见问题",
    subtitle: "我们在这里解释你可能想知道的所有内容。",
    extra: "让我们帮忙",
    "item-one": {
      title: "我该如何选择 Authing 的技术？",
      descript:
        "我该如何选择 Authing 的技术？请根据你的具体情况选择需要使用的技术。 开始之前，我们建议你阅读此文：",
      link: "为什么所有软件都应该使用单点登录来管理用户？",
    },
    "item-two": {
      title: "如何选择认证方式？",
      descript:
        "若你不理解什么是 OAuth、OIDC、SAML、LDAP 等标准协议且应用安全性要求不高，建议使用普通认证； 若你的应用安全性要求较高，无论是否了解标准协议，请使用标准协议认证。",
    },
    "item-three": {
      title: "Authing 是什么？",
      descript:
        "Authing 提供专业的身份认证和授权服务。 我们为开发者和企业提供用以保证应用程序安全所需的认证模块，这让开发人员无需成为安全专家。 你可以将任意平台的应用接入到 Authing（无论是新开发的应用还是老应用都可以），同时你还可以自定义应用程序的登录方式（如：邮箱/密码、短信/验证码、扫码登录等）。 你可以根据你使用的技术，来选择我们的 SDK 或调用相关 API 来接入你的应用。当用户发起授权请求时，Authing 会帮助你认证他们的身份和返回必要的用户信息到你的应用中。",
    },
    "item-four": {
      title: "为什么要使用 Authing？",
      other: "下面是我们整理的 Authing 的部分使用场景：",
      "descript-one":
        "你想开发一个很酷的程序，这时你想添加用户身份认证和授权。你希望你的用户能使用微信、Github 登录，同时你还希望能追踪到用户的注册来源，活动数据，以便你做后续的用户增长。",
      "descript-two":
        "你做了一个 API，同时你希望能使用 OAuth 2.0 协议保证 API 的安全。",
      "descript-three":
        "你做了很多应用程序，你希望这些应用程序的用户数据可以通过单点登录（Single Sign On）的方式互通。",
      "descript-four":
        "你做了一个 JavaScript 前端应用和一个移动端应用，你希望这两个客户端应用都可以安全的访问你的 API。",
      link: "阅读文档",
    },
  },
};
